/* eslint-disable @typescript-eslint/naming-convention */
import { AxiosResponse, AxiosError } from "axios";
import request from "#/utils/request";
import InternalResponse from "#/types/internalResponse";
import { authHeaders } from "#/modules/auth/idp";
import { MaliciousRequest } from "#/types/xecguard";

export type TraceRecordsParams = {
  start_at: string;
  end_at: string;
  service_token_id?: string;
  limit?: number;
  cursor?: string;
  violated_types?: string;
  violated_policy_names?: string;
  violated_scan_types?: string;
};

export type TraceRecordsPagination = {
  limit: number;
  has_next: boolean;
  next_cursor?: string;
};

export type TraceRecordsData = {
  unsafe_request_records: MaliciousRequest[];
  api_error_records: unknown[];
};

export type TraceRecordsResponse = {
  data: TraceRecordsData;
  pagination: TraceRecordsPagination;
};

export type TraceRecordsRequestType = {
  params: TraceRecordsParams;
  token: string;
};

export default function getTraceRecords({
  params,
  token,
}: TraceRecordsRequestType): Promise<InternalResponse<TraceRecordsResponse>> {
  return request()({
    url: "/xecguard/v1/stats/trace_records",
    method: "GET",
    params,
    headers: authHeaders(token),
  })
    .then(
      (result: AxiosResponse<TraceRecordsResponse>): InternalResponse<TraceRecordsResponse> => ({
        statusCode: result.status,
        data: result.data,
        success: true,
      }),
    )
    .catch(
      (error: AxiosError): InternalResponse => ({
        statusCode: error.code,
        msg: error.message,
        success: false,
      }),
    );
}
